/** Display helpers for employment work place + PT / work state. */

const MODE_LABELS = {
  HeadOffice: "Head Office",
  Office: "Head Office",
  Branch: "Branch",
  Hybrid: "Branch",
  Other: "Other / WFH",
  Remote: "Other / WFH",
};

export function workModeLabel(mode) {
  return MODE_LABELS[mode] || mode || "Head Office";
}

/**
 * Resolve the state shown on employee Job details.
 * Priority mirrors payroll PT: explicit compliance.pt_state, then branch/company.
 */
export function resolveWorkState(employee, locMap = {}, company = null) {
  const e = employee?.employment || {};
  const mode = e.work_mode || "HeadOffice";
  const explicit = (employee?.compliance?.pt_state || "").trim();
  if (explicit) return explicit;

  if (mode === "Branch" || mode === "Hybrid") {
    const loc = locMap[e.location_id];
    return (loc?.state || "").trim() || "—";
  }
  if (mode === "Other" || mode === "Remote") {
    return "—";
  }
  return (company?.state || "").trim() || "—";
}

export function workPlaceLabel(employee, locMap = {}) {
  const e = employee?.employment || {};
  const mode = e.work_mode || "HeadOffice";
  if (mode === "Branch" || mode === "Hybrid") {
    return locMap[e.location_id]?.name || e.work_location || "—";
  }
  if (mode === "Other" || mode === "Remote") {
    return e.work_location || "—";
  }
  return e.work_location || "Head Office";
}
